'use strict';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key]}}}return target};

const _=require('pulsar-utils/dist-es6/_');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const BaseZonedIntervalViewModel=require('./baseZonedIntervalViewModel');let

DutyViewModel=class DutyViewModel extends BaseZonedIntervalViewModel{
constructor(jsonDuty){
super(jsonDuty);

if(_.exists(jsonDuty.peak)){
this._peak=jsonDuty.peak;
}

if(_.exists(jsonDuty.metadata)){
this._metadata=jsonDuty.metadata;
}

if(_.exists(jsonDuty.splitBreak)){
this._splitBreak=new TimeInterval(jsonDuty.splitBreak);
}

if(_.exists(jsonDuty.splitBreakMinutes)){
this._splitBreakMinutes=jsonDuty.splitBreakMinutes;
}

this._sourceJson=_.cloneDeep(jsonDuty);
}

get splitBreak(){
return this._splitBreak;
}

get splitBreakMinutes(){
return this._splitBreakMinutes;
}

get peak(){
return this._peak;
}

get metadata(){
return this._metadata;
}

asSplitIntervals(){
if(this._splitIntervals){
return this._splitIntervals;
}

if(!this.splitBreak){
return this._splitIntervals=[this];
}

const firstInterval=new DutyViewModel(_extends({},
this._sourceJson,{
splitBreak:null,
end:this.splitBreak.start,
endTimeZone:this.startTimeZone}));


const secondInterval=new DutyViewModel(_extends({},
this._sourceJson,{
splitBreak:null,
start:this.splitBreak.end,
startTimeZone:this.startTimeZone}));


return this._splitIntervals=[_.assign(this,{customClass:'split-break full-duty'}),firstInterval,secondInterval];
}};


module.exports=DutyViewModel;
//# sourceMappingURL=dutyViewModel.js.map
